import { render, staticRenderFns } from "./SumForm.vue?vue&type=template&id=3dadfae6&scoped=true&"
import script from "./SumForm.vue?vue&type=script&lang=js&"
export * from "./SumForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dadfae6",
  null
  
)

export default component.exports